d<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <v-layout row wrap>
              <v-breadcrumbs divider="/" large disabled="false" class="pa-0">
                <v-icon slot="divider">chevron_right</v-icon>
                <v-breadcrumbs-item>
                  <v-btn color="blue" outline @click="gotoall" class="ma-0">Všechny sklady metal konto</v-btn>
                </v-breadcrumbs-item>
                <v-breadcrumbs-item :disabled="true">
                  {{dodavatel.nazev}}
                </v-breadcrumbs-item>
                <v-breadcrumbs-item :disabled="true">
                  {{material.nazev}}
                </v-breadcrumbs-item>
              </v-breadcrumbs>
            </v-layout>
            <v-layout row wrap class="mt-3">
              <v-flex xs12 sm3>
                <v-card color="grey lighten-4" class="no__radius">
                  <v-card-text>
                    <h3>{{stav_konta | formatMoney}} g</h3>
                    <p class="mb-0 caption">Aktuální stav metal konta</p>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
            <div class="table-border__radius elevation-1 mt-3">
              <v-data-table
                :headers="headers"
                :items="items"
                :loading="loadingTable"
                :pagination.sync="pagination"
                :total-items="pagination.totalItems"
                :rows-per-page-items="[25, 50, 100, 200]"
                class="mt-3"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.cas | formatDate }}</td>
                  <td><v-icon v-if="props.item.pocet_g > 0" small color="green" class="mr-1">arrow_upward</v-icon><v-icon v-else small color="red" class="mr-1">arrow_downward</v-icon> {{ props.item.pocet_g | formatMoney }} g</td>
                  <td></td>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: true,
      headers: [
        { text: 'Datum', value: 'cas' },
        { text: 'Množství', value: 'pocet_g' },
        { text: 'Doklad', value: 'doklad', sortable: false }
      ],
      items: [],
      dodavatel: null,
      nazev: null,
      loadingTable: false,
      timeout: null,
      counter: 0,
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 25,
        sortBy: "cas",
        totalItems: 0
      },
      stav_konta: 0
    }
  },
  watch: {
    pagination: {
      deep: true,
      handler (v) {
        this.load();
      }
    }
  },
  props: {
    id: String
  },
  mounted () {
    this.load();
  },
  methods: {
    gotoall () {
      this.$router.push({ path: "/sklad/sklad-metal-konto" });
    },
    load: function() {
      this.counter++;
      this.loadingTable = true;
      window.API.post("sklady/metal-konto/" + this.$props.id + "/pohyby/search", {
        echo: this.counter,
        pagination: this.pagination
      }).then(function(body) {
        if (this.counter != body.echo)
          return;
        this.items.replace(body.data);
        this.dodavatel = body.dodavatel;
        this.material = body.material;
        this.stav_konta = body.stav_konta;
        this.pagination.sortBy = body.sort.sortBy;
        this.pagination.descending = body.sort.descending;
        this.pagination.page = body.sort.page;
        this.pagination.rowsPerPage = body.sort.rowsPerPage;
        this.pagination.totalItems = body.sort.totalItems;
        this.loading = false;
        this.loadingTable = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    }
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Sklady/PohybyMaterialu.vue